import $ from 'jquery';

if( $( "html" ).attr("dir") == "rtl" ) {
	var rtl = true;
} else {
	var rtl = false;
}

$( '.js-ticker-slider').slick( {
    rtl: rtl,
	slidesToShow: 6,
	slidesToScroll: 1,
	autoplay: true,
	adaptiveHeight: true,
  	autoplaySpeed: 0,
	speed: 3500,
	cssEase: 'linear',
	pauseOnHover: false,
	nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg width="1em" height="1em" viewBox="0 0 23 20" xmlns="http://www.w3.org/2000/svg"><g stroke="currentColor" fill="none" fill-rule="evenodd"><path d="M-13.5-13.5h46v46h-46z"/><path d="M11.848.011l9.9 9.9-9.193 9.192"/><path stroke-linecap="square" d="M20.5 9.5H.5"/></g></svg></button>',
	prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg width="1em" height="1em" viewBox="0 0 24 22" xmlns="http://www.w3.org/2000/svg"><path stroke="currentColor" fill="transparent" d="M-10.5-12.5h46v46h-46z"/><g stroke="currentColor"><path fill="transparent" d="M11.555 1.011l-9.899 9.9 9.192 9.192"/><path stroke-linecap="square" d="M2.5 10.5h20"/></g></g></svg></button>',
	responsive: [
		{
			breakpoint: 980,
			settings: {
				slidesToShow: 4,
			},
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 1,
			},
		},
	],
} );